const schedulesPath = 'downloadable_resource/schedules'

export default {
  /*
   * index() lista los ficheros descargables de horarios
   */
  index(params) {
    return Vue.http.get(schedulesPath, {params}).then(response => response.data.data)
  }
}
